module.exports = __webpack_public_path__ + "static/img/36.8114dc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/36.png
// module id = depa
// module chunks = 0